<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormLegalDetail
          :data="legalDetail"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          @submit="onFormSubmit"
          @delete-detail="onDeleteDetail"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmDetailDelete" confirmText="Удалить" />
  </v-container>
</template>

<script>
// Components
import FormLegalDetail from './form/FormLegalDetail'
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog'
// GQL
import legalDetailQuery from '@/services/gql/types/LegalDetail/queries/legalDetail.graphql'
import deleteLegalDetailMutation from '@/services/gql/types/LegalDetail/mutations/deleteLegalDetail.graphql'
import updateLegalDetailMutation from '@/services/gql/types/LegalDetail/mutations/updateLegalDetail.graphql'
export default {
  name: 'PageLegalDetail',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: { ConfirmationDialog, FormLegalDetail },
  data () {
    return {
      legalDetail: {}
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.legalDetail.loading
    },
    isMutationLoading () {
      return this.$async.updateDetail.$pending ||
        this.$async.deleteDetail.$pending
    }
  },
  methods: {
    async onFormSubmit (formData) {
      try {
        await this.$async.updateDetail.$perform({
          id: this.id,
          data: formData
        })
        this.$successMsg('Анкета успешно сохранена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при сохранении анкеты пользователя')
      }
    },
    async onDeleteDetail () {
      try {
        if (await this.$refs.confirmDetailDelete.open()) {
          await this.$async.deleteDetail.$perform({ id: this.id })
          this.$successMsg('Анкета успешно удалена')
        }
      } catch (e) {
        if (!e.cancel) {
          this.$handleApiError(e.graphQLErrors, `Ошибка при удалении анкеты с ID ${this.id}`)
        }
      } finally {
        await this.$router.push({ name: 'page-legal-details' })
      }
    }
  },
  apollo: {
    legalDetail: {
      query: legalDetailQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: this.id
          }
        }
      }
    }
  },
  async: {
    deleteDetail (variables) {
      return this.$apollo.mutate({
        mutation: deleteLegalDetailMutation,
        variables
      })
    },
    updateDetail (variables) {
      return this.$apollo.mutate({
        mutation: updateLegalDetailMutation,
        variables
      })
    }
  }
}
</script>
